import { setCookie, getCookie } from "@/services/cookies";
import { CookieName, CookieRegistry } from "@/services/cookieRegistry";

const { name: cookieName } = CookieRegistry[CookieName.LoginMarker];

/**
 * Stores info about login in browser.
 * We can detect if someone was already logged in in this exact browser.
 */
export const LoginMarkerService = {
  markLogin: (): void => {
    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + 1);
    setCookie(cookieName, "1", { expiration: expiration.toUTCString(), path: "/" });
  },

  wasSomeoneEverLoggedIn: (): boolean => {
    const cookie = getCookie(cookieName);
    return cookie !== null;
  },
};
